import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { LanguageSwitcher } from './LanguageSwitcher';

const navItems = [
  { to: '/', key: 'home', end: true, label: 'Главная' },
  { to: '/upload', key: 'upload', end: false, label: 'Загрузить' },
  { to: '/deals', key: 'deals', end: false, label: 'Сделки' },
  { to: '/hs-lookup', key: 'hsLookup', end: false, label: null },
  { to: '/duty-calc', key: 'dutyCalc', end: false, label: null },
  { to: '/doc-generator', key: 'docGenerator', end: false, label: null },
  { to: '/tnved-matcher', key: 'tnvedMatcher', end: false, label: null },
] as const;

export function Header(): JSX.Element {
  const { t } = useTranslation();

  return (
    <header className="border-b border-ntr-primary/10 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-lg font-semibold text-ntr-primary">
            {t('app.title')}
          </h1>
          <p className="text-xs text-ntr-muted">{t('app.subtitle')}</p>
        </div>
        <LanguageSwitcher />
      </div>
      <nav className="mx-auto flex max-w-6xl flex-wrap gap-1 px-6 pb-3">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              'rounded-md px-3 py-1.5 text-sm font-medium transition ' +
              (isActive
                ? 'bg-ntr-primary text-white'
                : 'text-ntr-text hover:bg-ntr-primary/10')
            }
          >
            {item.label ?? t(`nav.${item.key}`)}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
